import React from 'react';
import { 
  Box, 
  Alert, 
  AlertIcon, 
  AlertTitle, 
  AlertDescription,
  Code,
  Button,
  Collapse,
  useDisclosure
} from '@chakra-ui/react';

/**
 * Component to display detailed error information for debugging
 */
const ErrorDisplay = ({ error, txError }) => {
  const { isOpen, onToggle } = useDisclosure();
  
  if (!error && !txError) return null;
  
  return (
    <Box mt={4} mb={8}>
      <Alert 
        status="error" 
        variant="subtle"
        flexDirection="column"
        alignItems="flex-start"
        borderRadius="md"
        boxShadow="md"
      >
        <AlertIcon />
        <AlertTitle mt={0} mb={2} fontSize="lg">
          Error Loading Data
        </AlertTitle>
        <AlertDescription>
          {error || txError || "An unknown error occurred while fetching data"}
        </AlertDescription>
        
        <Button 
          onClick={onToggle} 
          size="sm" 
          colorScheme="red" 
          variant="outline"
          mt={3}
        >
          {isOpen ? "Hide Details" : "Show Technical Details"}
        </Button>
        
        <Collapse in={isOpen} animateOpacity w="100%">
          <Box 
            mt={4} 
            p={3} 
            bg="blackAlpha.300" 
            borderRadius="md" 
            fontSize="sm"
            overflowX="auto"
          >
            <Code w="100%" display="block" whiteSpace="pre-wrap">
              {`Error: ${error || txError || "Unknown error"}

Debugging Information:
- Browser: ${navigator.userAgent}
- URL: ${window.location.href}
- Time: ${new Date().toISOString()}
- Network: ${process.env.REACT_APP_RPC_URL || 'Default RPC'}

If this error persists, please:
1. Check your network connection
2. Make sure the Base network is available
3. Verify that you're using a compatible browser
4. Try refreshing the page`}
            </Code>
          </Box>
        </Collapse>
      </Alert>
    </Box>
  );
};

export default ErrorDisplay;